/* pantallas-alumno (C): EL ESQUELETO DEL CENTRO DE ESTUDIO (CE11).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Copia el acomodo nuevo con las MISMAS cajas de la pagina (`acomodoDelCentro.js`): el titulo, las
   tres tarjetas de modo (mismo alto minimo que `TarjetaDeModo`), la lista con 5 renglones de 56 y la
   caja Settings. En tablet y computadora el boton de Start va en su lugar, apagado (45 %); en el
   celular la barra fija la monta la pagina (ya esta ahi con "Start studying" apagado). Los bloques
   son los del Panel (`BloqueEsqueleto`, degradado #181818 a #232323).

   `textos` (cotejo con el PDF, CE11 p33; la parte 2: "los encabezados se ven desde el principio"): con
   las traducciones listas la pagina le pasa {titulo, subtitulo, documentos, settings, start, startCorto}
   y el esqueleto pinta el titulo, el subtitulo, los rotulos "Select Documents" (con su icono) y "Settings"
   con las clases de la pagina, y el Start apagado con su texto. Sin `textos` (antes de que lleguen las
   traducciones) se pinta como antes: solo bloques.

   smoke-alumno, S1: `clase` lleva la holgura de la barra fija del celular (la de la pagina), y la caja de
   documentos, su lista y Settings copian el acomodo nuevo (la caja se lleva lo que sobra y la lista va absoluta
   dentro de ella), para que el esqueleto llene el chasis igual que la pagina.

   centro-espacio (orden de Carlos del 20-oct): sin `escalon` (los escalones se fueron) y sin subtitulo; las tarjetas
   de modo con las medidas nuevas (como mucho 64 en el celular y 96 desde 768); `estilo` lleva el aire medido de
   abajo de la pagina (el mismo `paddingBottom`). `textos.subtitulo`, si llega, ya no se pinta.

   centro-espacio-2: el bloque de "{n} documents selected" sale solo desde 1024, como en la pagina. */
import React from 'react';
import { FileText, Play } from 'lucide-react';
import { BloqueEsqueleto, Boton } from '../alumno';
import {
  RECUADRO_DEL_CENTRO, PEGADO_EN_COMPU, PAGINA_DEL_CENTRO, REJILLA_DEL_CENTRO, CAJA_DE_LA_LISTA, PIE_DE_SETTINGS,
  TITULO_DEL_CENTRO, TITULO_DEL_RECUADRO,
  RECUADRO_DE_DOCUMENTOS, LISTA_DEL_CENTRO, SETTINGS_DEL_CENTRO,
} from './acomodoDelCentro';

const TARJETA_DE_MODO = 'rounded-[18px] border border-[#222222] bg-[#141414] min-h-[52px] px-1.5 py-1.5 md:p-3 flex flex-col max-md:items-center max-md:justify-center';

export default function EsqueletoDelCentro({ textos, clase, estilo } = {}) {
  return (
    <div className={clase ? `${PAGINA_DEL_CENTRO} ${clase}` : PAGINA_DEL_CENTRO} style={estilo} data-testid="skeleton-study-center" aria-hidden="true">
      {textos ? (
        <div>
          <h1 className={TITULO_DEL_CENTRO}>{textos.titulo}</h1>
        </div>
      ) : (
        <div>
          <BloqueEsqueleto className="h-7 md:h-10 w-48" />
        </div>
      )}
      <div className="mt-1 grid grid-cols-3 gap-2 md:gap-4 items-stretch">
        {[0, 1, 2].map((i) => (
          <div key={i} className={TARJETA_DE_MODO}>
            <span className="flex flex-col md:flex-row md:items-center gap-1 md:gap-1.5 max-md:items-center">
              <BloqueEsqueleto className="w-6 h-6 lg:w-7 lg:h-7 rounded-lg" />
              <BloqueEsqueleto className="h-4 w-16 md:w-28" />
            </span>
            <BloqueEsqueleto className="max-md:hidden mt-2 h-3 w-full" />
          </div>
        ))}
      </div>
      <div className={REJILLA_DEL_CENTRO}>
        <div className={`${RECUADRO_DEL_CENTRO} ${RECUADRO_DE_DOCUMENTOS}`}>
          {textos ? (
            <h2 className={TITULO_DEL_RECUADRO}>
              <FileText className="w-[18px] h-[18px] shrink-0 text-[#F27A2E]" aria-hidden="true" />
              {textos.documentos}
            </h2>
          ) : <BloqueEsqueleto className="h-6 w-44" />}
          <div className={CAJA_DE_LA_LISTA}>
          <div className={LISTA_DEL_CENTRO}>
            {[0, 1, 2, 3, 4].map((i) => (
              <div key={i} className="min-h-[56px] px-[14px] rounded-xl border border-[#1F1F1F] bg-[#101010] flex items-center gap-3">
                <BloqueEsqueleto className="w-[22px] h-[22px] rounded-[7px]" />
                <BloqueEsqueleto className="h-4 flex-1" />
                <BloqueEsqueleto className="h-3 w-14" />
              </div>
            ))}
          </div>
          </div>
        </div>
        <div className={`${RECUADRO_DEL_CENTRO} ${SETTINGS_DEL_CENTRO} ${PEGADO_EN_COMPU}`}>
          {textos ? <h2 className={TITULO_DEL_RECUADRO}>{textos.settings}</h2> : <BloqueEsqueleto className="h-6 w-24" />}
          <BloqueEsqueleto className="mt-3 h-3 w-full" />
          <BloqueEsqueleto className="mt-2 h-3 w-2/3" />
          <div className={PIE_DE_SETTINGS}>
            <BloqueEsqueleto className="max-lg:hidden h-4 w-36" />
            {textos ? (
              <Boton disabled alto="barra" aLoAncho icono={Play} tabIndex={-1}
                className="!rounded-[14px] !text-[16px]" testid="skeleton-start">
                <span className="lg:hidden xl:inline">{textos.start}</span>
                <span className="hidden lg:inline xl:hidden">{textos.startCorto}</span>
              </Boton>
            ) : (
              <div data-testid="skeleton-start" className="h-[52px] w-full rounded-[14px] bg-[#F27A2E] opacity-45" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
